<form [formGroup]="formUpdate" class="card p-4" (ngSubmit)="openDialog()">
    <div class="col">
      <div class="row">
        <h2 class="w-100">{{ 'PROCEDIMIENTO.EDIT.TITLE' | translate }}</h2>
      </div>
    </div>
    <h6 class="w-100 subtitle">{{ 'PROCEDIMIENTO.EDIT.NAME' | translate }}</h6>
    <input placeholder="{{procedimiento.nombre}}" type="text" class="textbox-n w-100" formControlName="nombre" name="nombre">
    <!-- <h6 class="w-100 subtitle">Descripcion</h6>
    <textarea name="textarea" cols="40" rows="5" class="w-100" formControlName="descripcion"></textarea> -->
    <div class="mat-column-fecha w-100">
      <h6 class="w-100 subtitle">{{ 'PROCEDIMIENTO.EDIT.DATE_ACTIVE' | translate }}</h6>
      <div class="w-100 d-flex">
        <div class="w-100 d-flex " *ngIf="procedimiento.fechaApertura != null">
          <div class="dateDiv">
            <input
              placeholder="{{('0'+procedimiento.fechaApertura[2]) | slice:-2}}/{{('0'+procedimiento.fechaApertura[1]) | slice:-2}}/{{('0'+procedimiento.fechaApertura[0]) | slice:-4}}"
              type="text" onfocus="(this.type='date')" onblur="this.value==''?this.type='text': this.type='date'"
              class=" textbox-n d-block widthDate" formControlName="fechaApertura">
          </div>
          <span style="width: 5%;"></span>
          <input placeholder="{{('0'+procedimiento.fechaApertura[3]) | slice:-2}}:{{('0'+procedimiento.fechaApertura[4]) | slice:-2}}" type="text"
            onfocus="(this.type='time')" onblur="(this.type='text')" class="textbox-n d-block widthTime"
            formControlName="horaApertura">
        </div>
        <div class="w-100 d-flex" *ngIf="procedimiento.fechaApertura == null">
          <div class="dateDiv">
            <input type="date" formControlName="fechaApertura" class="d-block ">
          </div>
          <span style="width: 5%;"></span>
          <input type="time" formControlName="horaApertura" class="d-block">
        </div>
      </div>
      <div *ngIf="fechaAperturaIncompletaWarning" class="alert alert-danger my-2">
        <p>Si quiere añadir una fecha, debe rellenar tanto el campo fecha como el campo hora</p>
      </div>
      <h6 class="w-100 subtitle">{{ 'PROCEDIMIENTO.EDIT.DATE_INACTIVE' | translate }}</h6>
      <div class="w-100 d-flex" >
        <div class="w-100 d-flex " *ngIf="procedimiento.fechaCierre != null">
          <div class="dateDiv">
            <input
              placeholder="{{('0'+procedimiento.fechaCierre[2]) | slice:-2}}/{{('0'+procedimiento.fechaCierre[1]) | slice:-2}}/{{('0'+procedimiento.fechaCierre[0]) | slice:-4}}"
              type="text" onfocus="(this.type='date')" onblur="if(this.value==''){this.type='text'}else this.type='date'"
              class=" textbox-n d-block widthDate" formControlName="fechaCierre">
          </div>
          <span style="width: 5%;"></span>
          <input placeholder="{{('0'+procedimiento.fechaCierre[3]) | slice:-2}}:{{('0'+procedimiento.fechaCierre[4]) | slice:-2}}" type="text"
            onfocus="(this.type='time')" onblur="(this.type='text')" class="textbox-n d-block widthTime"
            formControlName="horaCierre">
        </div>
        <div class="w-100 d-flex " *ngIf="procedimiento.fechaCierre == null">
          <div class="dateDiv">
            <input type="date" formControlName="fechaCierre" class="d-block ">
          </div>
          <span style="width: 5%;"></span>
          <input type="time" formControlName="horaCierre" class="d-block">
        </div>
      </div>
      <div *ngIf="fechaCierreIncompletaWarning" class="alert alert-danger my-2">
        <p>Si quiere añadir una fecha, debe rellenar tanto el campo fecha como el campo hora</p>
      </div>
    </div>
    
    <div class="w-100 d-flex mt-3">
      <div *ngIf="procedimiento.visible == true" class="mat-column-visible">
        <mat-checkbox [checked]=true (change)="updateVisibility($event)"></mat-checkbox>
      </div>
      <div *ngIf="procedimiento.visible == false" class="mat-column-visible">
        <mat-checkbox [checked]=false (change)="updateVisibility($event)"></mat-checkbox>
      </div>
      <h6 class="ml-3  subtitle my-0">{{ 'PROCEDIMIENTO.EDIT.ACTIVE' | translate }}</h6>
    </div>
    <div class="w-100 d-flex mt-3 justify-content-between" >
      <button type="button" (click)="onNoClick()" class="py-2 btn btn-secondary m-left footer-btn">{{ 'NOTIFICATION.BUTTON.CANCEL' | translate }}</button>
      <button type="submit" class="py-2 btn  btn-primary m-left footer-btn">{{ 'COMMON.BUTTON.SAVE' | translate }}</button>
    </div>
    
  </form>